export const toNumber = (value: string | number): number => {
  if (typeof value === 'number') {
    return value
  }
  if (typeof value === 'string') {
    return Number(value.replace(',', '.'))
  }

  return value
}
